var render, staticRenderFns
import script from "./YwTable.vue?vue&type=script&lang=js"
export * from "./YwTable.vue?vue&type=script&lang=js"
import style0 from "./YwTable.vue?vue&type=style&index=0&id=58f30b7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f30b7a",
  null
  
)

export default component.exports